import { StyleSheet } from 'react-native';

import { EPGConfig } from '../../types';

const getStyles = (config: EPGConfig) =>
    StyleSheet.create({
        container: {
            width: config.hourWidth,
            alignItems: 'stretch',
            justifyContent: 'center',
        },
    });

export default getStyles;
